import orderUtil from "../Utils/orderUtil.js";
const Css = {
  vibrationBox(w){
    return {
      width: w + "px",
      height: orderUtil.controlBoxHeight + "px",
      float: "left",
      backgroundColor: "#121212"
    }
  },
  vTimeArea(w){
    return  {
      width: w + "px",
      height: "44px",
      lineHeight: "44px",
      backgroundColor: "#252525",
      fontFamily: "OpenSans-Semibold",
      fontSize: "14px",
      color: "#278DE7",
      textAlign: "center"
    }
  },
  lsArea(w){
    return {
      width: w + "px",
      height: orderUtil.canvasHeight + "px",
      backgroundColor: "#252525",
      marginTop: "2px",
      txt: {
        width: "100%",
        height: "30px",
        lineHeight: "30px",
        textAlign: "center",
        fontFamily: "OpenSans",
        fontSize: "13px",
        color: "#ccc",
        float: "left"
      }
    }
  },
  vImag(width){
    let tmp = parseInt((width - 36)/2) + "px";
    return {
      width: "36px",
      height: "36px",
      margin: "66px " + tmp + " 6px",
      float: "left",
      borderRadius: "50%"
    }
  } 
}

export default Css;